// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5n-1";
export var standaloneTable = "_5n-0";